import { logger } from '@getvim/vim-connect-logger';
import { gqlClient } from './gql-client';

export const setGlobalAccessToken = (accessToken: string): void => {
  logger.setAccessToken(accessToken);
  gqlClient.setAccessToken(accessToken);
};
